var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.66 4.34H4.34v9.32h9.32V4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M13.66 13.66H4.34v4.204h9.32v-4.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.66.136H1.538A1.411 1.411 0 0 0 .136 1.537v12.124h4.203V4.339h9.322V.136Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M.136 13.66v2.803a1.411 1.411 0 0 0 1.401 1.401h2.802v-4.203H.136Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M17.864 4.34h-4.203v9.32h4.203V4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M17.864 4.34V1.536A1.411 1.411 0 0 0 16.463.136h-2.802v4.203h4.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "m13.66 17.864 4.204-4.203h-4.203v4.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A83F8",
    d: "m10.32 8.165-.446-.63 1.586-1.147h.602v5.395H11.2V7.49l-.88.674ZM8.337 8.945a1.474 1.474 0 0 0 .65-1.201c0-.839-.747-1.517-1.67-1.517a1.64 1.64 0 0 0-1.634 1.206l.74.295a.825.825 0 0 1 .836-.657.773.773 0 1 1 .012 1.54v.001h-.457v.725h.51a.879.879 0 1 1 0 1.75 1.001 1.001 0 0 1-.74-.317.86.86 0 0 1-.15-.232l-.131-.318-.781.303c.116.808.876 1.434 1.795 1.434 1.001 0 1.812-.74 1.812-1.65a1.613 1.613 0 0 0-.792-1.362Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.959b8fa95633b9cc835fc0bed2ada1db.svg";
export { ForwardRef as ReactComponent };